import type React from 'react';

import type { PaginationProps } from '~/components/Pagination/Pagination';
import { Pagination } from '~/components/Pagination/Pagination';
import { useIsExternalUser } from '~/hooks/useIsExternalUser';
import { env } from '~/lib/env';
import type { FilterEntity } from '~/modules/settings/components/FilterList/hooks/useFilterChips';

import { FilterList } from './FilterList/FilterList';
import { Toolbar } from './Toolbar';

interface ListControlsProps extends PaginationProps {
  entity: string;
  placeholder: string;
  setPageNumber: (page: number) => void;
  onFilterClick?: () => void;
  toolbarRightAddon?: React.ReactNode;
  internalFilter?: React.ReactNode;
  searchTerm?: string;
  setSearchTerm?: (term: string) => void;
}

export const ListControls: React.FC<ListControlsProps> = ({
  page,
  total,
  perPage,
  entity,
  placeholder,
  setPageNumber,
  onFilterClick,
  toolbarRightAddon,
  internalFilter,
}) => {
  const isCurrentUserExternal = useIsExternalUser();
  const readOnlyIsNotEnabled =
    env('VITE_CONTAINER_SETTINGS_READ_ONLY_ENABLED', false) === 'false';

  return (
    <>
      {readOnlyIsNotEnabled ? (
        <>
          <Toolbar
            placeholder={placeholder}
            rightAddon={toolbarRightAddon}
            onFilterClick={onFilterClick}
            setPageNumber={setPageNumber}
          />
          <div className="flex items-center justify-start gap-sm">
            {!isCurrentUserExternal && (
              <>
                <div className="flex-none">{internalFilter} </div>
                <span className="mx-sm inline-block h-lg w-px bg-emphasis-subtle" />
              </>
            )}
            <div className="flex-1">
              {onFilterClick ? (
                <FilterList entity={entity as FilterEntity} />
              ) : null}
            </div>
            <div className="flex-none">
              <Pagination
                page={page}
                total={total}
                perPage={perPage}
                entity={entity}
                setPageNumber={setPageNumber}
              />
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

ListControls.displayName = 'ListControls';
